export default {
    system: {
        webTitleDev: '物业管理系统（测试）',
        webTitle: '物业管理系统',
		logout: '退出',
		cancel: '取消',
		primaryColor: '主题颜色',
		weakMode: '色弱模式',
		layout: '框架布局',
		pageLayout: '页面布局',
		pleaseSelect: '请选择',
		default: '默认',
		fullWidth: '通栏',
		multiColumn: '分栏',
		classic: '经典',
		dock: '横向',
		float: '浮动',
		collapseMenu: '折叠菜单',
		showLabels: '显示标签',
    },
	login: {
		userError: '请输入用户名',
		PWError: '请输入密码',
		codeError: '请输入验证码',
		rememberMe: '记住密码',
		signIn: '登录',
		userPlaceholder: '用户名 / 手机 / 邮箱',
		PWPlaceholder: '请输入密码',
		codePlaceholder: '请输入验证码'
	},
	user: {
		dynamic: '近期动态',
		info: '个人信息',
		settings: '设置',
		thememode: '主题风格',
		nightmode: '黑夜模式',
		nightmode_msg: '适合光线较弱的环境，当前黑暗模式为beta版本',
		language: '语言',
		language_msg: '翻译进行中，暂翻译了本视图的文本',
	}
}
